import React, { useRef } from 'react';
import { FieldRenderProps } from 'react-final-form';
import { Form, Icon, Input, SemanticICONS } from 'semantic-ui-react';
import { InputOnChangeData } from 'semantic-ui-react/dist/commonjs/elements/Input/Input';
import styled from 'styled-components';

export const StyledFormField = styled(Form.Field)`

  & .input-error-message {
    margin-top: 0.3rem;
    font-size: 0.875rem;
    color: #9f3a38;
  }
`;

export const StyledInput = styled(Input)`

  &.ui.input > input {
    padding: 5px 5px;
    max-height: 29px;
    min-height: 29px;
  }

  &.ui.mini.input > input {
    font-size: 1rem;
  }
`;

export interface FinalFormInputProps extends FieldRenderProps {
  autoComplete?: "on" | "off" | "nope",
  className?: string,
  hiddenInput?: boolean,
  maxLength?: number,
  icon?: any,
  // Enables modifying the value before it's propagated to final form.
  // E.g. automatically convert any entered text to uppercase.
  onChangeDecorator?: (inputElement: HTMLInputElement, value: string) => void,
  onPaste?: (evt: any) => void,
  onDrop?: (evt: any) => void,
  showError?: boolean
}

const FinalFormInput = (props: FinalFormInputProps) => {

  const {
    input,
    meta: {touched, error},
    autoComplete = "nope",
    hiddenInput,
    onChangeDecorator,
    showError,
    icon,
    ...restProps
  } = props;

  const inputRef = onChangeDecorator ? useRef<HTMLInputElement>(null) : undefined;

  let onChange: (evt: any, data?: any) => void = props.input.onChange;
  if (onChangeDecorator) {
    onChange = (
        event: React.ChangeEvent<HTMLInputElement>,
        data: InputOnChangeData) => {

      const value = data.value;
      const inputEl = inputRef!.current!;
      onChangeDecorator(inputEl, value);

      props.input.onChange(event);
    }
  }

  const stringIcon = (typeof icon === 'string' || icon instanceof String);

  return (
      <StyledFormField>
        <StyledInput error={!!(touched && error)}
                     className={props.className}
                     {...input}
                     {...restProps}
                     autoComplete={autoComplete}
                     size="mini"
                     icon={!!icon}
                     onChange={onChange}
        >
          <input ref={onChangeDecorator ? inputRef : undefined}/>
          {
            stringIcon
              ? <Icon name={(icon as SemanticICONS)}/>
                : icon
          }
        </StyledInput>
        {showError && touched && error && <div className="input-error-message">{error}</div>}
      </StyledFormField>
  );
};

export default FinalFormInput;
